<!--
@author: chenjl
@date: 23.3.24
@description: icon按钮，文字在tooltip上
-->
<template>
  <div class="api-btn-wrapper">
    <el-tooltip
      effect="light"
      :disabled="!tip"
      :content="tip"
      :placement="placement"
    >
      <div class="api-btn" @click="handleClick" :style="{
        width: size,
        height: size,
        fontSize: size,
      }">
        <svg :style="{
          transform: transform
        }" width="0.5em" height="0.5em" fill="currentColor" aria-hidden="true" focusable="false" class="">
          <use :xlink:href="`#${icon}`"></use>
        </svg>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ApiBtn'
}
</script>

<script setup>
import { defineProps, defineEmits } from 'vue'
defineProps({
  icon: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: ''
  },
  placement: {
    type: String,
    default: 'top'
  },
  size: {
    type: String,
    default: '32px'
  },
  transform: {
    type: String,
    default: 'rotate(0)'
  }
})

const emit = defineEmits(['click'])
const handleClick = () => {
  emit('click')
}


</script>
<style lang="less" scoped>
.api-btn-wrapper {
  .api-btn {
    cursor: pointer;
    transition: all .2s linear;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    // svg {
    //   color: 
    // }

    &:hover {
      background-color: rgba(16, 24, 40, 0.04);
    }
  }
}
</style>
